/* eslint-disable */
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}

export function maxLength(max) {
  return { max: Number(max), message: '最大长度' + max + '个字符' };
}

function length(min = 1, max) {
  return { min: Number(min), max: Number(max), message: '长度在' + min + '到' + max + '个字符' };
}

export function required() {
  return { required: true, pattern: /\S/, message: '不能为空' };
}

export function requiredArray() {
  return { required: true, type: Array,  pattern: /\S/, message: '不能为空' };
}

// 账号
export function userName() {
  return { pattern: /^[a-zA-Z0-9]+$/, message: '只能输入字母和数字' }
}

// 验证邮箱
export function email() {
  return { pattern: /^(\w)+(\.\w+)*@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/, message: '邮箱格式不正确' }
}

// 验证手机号
export function phone() {
  return { pattern: /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/, message: '手机号格式错误' }
}

// 验证密码
export function pwd() {
  return {
    pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])[\da-zA-Z_@!.&*-]{8,32}$/,
    message: '同时包含大写字母、小写字母和数字，密码长度为8-32个字符'
  }
}

// 正整数
export function isValidPositiveInteger() {
  return { pattern: /^[0-9]+$/, message: '只能输入正整数' }
}

// 只能输入字母和数字
export function isValidAlphaNumeric() {
  return { pattern: /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/, message: '只能输入字母和数字和特殊符号' }
}

const valid = {
  required,
  requiredArray,
  length,
  userName,
  email,
  phone,
  pwd,
  isValidPositiveInteger,
  isValidAlphaNumeric
}

export function validator(rules) {
  return rules.map((type) => {
    if (type.indexOf('length') !== -1) {
      const regex = /[^\(\)]+(?=\))/g
      let params = type.match(regex)
      params = params.toString().split(',')
      if (params.length === 1) {
        return maxLength(params[0])
      }
      return length(...params)
    } else {
      const r = valid[type]();
      return r;
    }
  });
}
